export async function snapshotCapturedFile(file: File): Promise<File> {
  const bytes = await file.arrayBuffer();
  return new File([bytes], file.name || "capture.jpg", {
    type: inferImageMimeType(file),
    lastModified: file.lastModified,
  });
}

function inferImageMimeType(file: File): string {
  if (file.type) return file.type;
  const name = file.name.toLowerCase();
  if (name.endsWith(".png")) return "image/png";
  if (name.endsWith(".heic")) return "image/heic";
  if (name.endsWith(".heif")) return "image/heif";
  if (name.endsWith(".webp")) return "image/webp";
  return "image/jpeg";
}
